//Bio_F	Foraminifera
// Bio_N	Calcareous Nannofossil
// Bio_R	Radiolaria
// Bio_D	Diatom
// RD	Radiometric Dating
// M	Magnetostratigraphy
export function getLabel(name) {
  switch (name) {
    case 'Bio_F':
      return 'Foraminifera';
    case 'Bio_N':
      return 'Calcareous Nannofossil';
    case 'Bio_R':
      return 'Radiolaria';
    case 'Bio_D':
      return 'Diatom';
    case 'RD':
      return 'Radiometric Dating';
    case 'M':
      return 'Magnetostratigraphy';
    default:
      return '';
  }
}
export function getSymbol(name) {
  switch (name) {
    case 'Bio_F':
      return 'circle';
    case 'Bio_N':
      return 'rect';
    case 'Bio_R':
      return 'triangle';
    case 'Bio_D':
      return 'diamond';
    case 'RD':
      return 'image://https://mystorage-1314929303.cos.ap-chengdu.myqcloud.com/star.png';
    case 'M':
      return 'arrow';
    default:
      return '';
  }
}

export function getStandard(name) {
  switch (name) {
    // case 'TSC':
    //   return 'age_TSC';
    // case 'GTS2020':
    //   return 'age_GTS2020';
    // case 'GTS2012':
    //   return 'age_GTS2012';
    // case 'NSB':
    //   return 'age_Neptune';
    case 'Original':
      return 'age_Original';
    default:
      return 'standard_Age';
  }
}

export function getColor(name) {
  switch (name) {
    case 'Bio_F':
      return '#97EF72';
    case 'Bio_N':
      return '#EFDE72';
    case 'Bio_R':
      return '#C9A3F3';
    case 'Bio_D':
      return '#F1654C';
    case 'RD':
      return '#616060';
    case 'M':
      return '#4BC1DF';
    default:
      return '';
  }
}
export function getHomeColor(item) {
  if (!item.event && !item.bchron) {
    return 'black';
  } else if (item.event && !item.bchron) {
    return 'blue';
  } else if (item.bchron && !item.event) {
    return 'green';
  } else {
    return 'red';
  }
}

export function getHomeName(item) {
  if (!item.event && !item.bchron) {
    return 'Hole without age data';
  } else if (item.event && !item.bchron) {
    return 'Hole with Stratigraphic event';
  } else if (item.bchron && !item.event) {
    return 'Hole with Bchron age model';
  } else {
    return 'Hole with Stratigraphic event and Bchron age model';
  }
}
